import { styled } from '@linaria/react';

import { DEMO_COLORS_DARK } from '@/constants/Wham.colors';

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  isToggled: boolean;
  children: React.ReactNode;
}

function CheckmarkButton({
  isToggled,
  children,
  ...delegated
}: Props) {
  return (
    <Button {...delegated}>
      <PseudoCheckbox>{isToggled && <StyledCheck />}</PseudoCheckbox>
      <ButtonText>{children}</ButtonText>
    </Button>
  );
}

function Check(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 6L9 17L4 12"
        stroke="var(--color-background)"
        strokeWidth="12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <GreenCheckPath d="M20 6L9 17L4 12" />
    </svg>
  );
}

const Button = styled.button`
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px;
  font-size: 1rem;
  border: 1px solid var(--color-gray-300);
  border-radius: 4px;
  background: var(--color-background);
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    --color-background: var(--color-gray-100);
  }

  &:active {
    outline: 3px solid var(--color-gray-300);
    outline-offset: 0px;
  }
  &:focus:active {
    outline-offset: 0px;
    outline: 1px solid var(--color-gray-300);
  }
`;

const PseudoCheckbox = styled.span`
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border: 2px solid var(--color-gray-300);
  border-radius: 4px;
`;

const StyledCheck = styled(Check)`
  position: absolute;
  width: 16px;
  height: 16px;
  max-width: revert;
  inset: 0;
  transform: translate(0px, -4px);
`;

const GreenCheckPath = styled.path`
  stroke: hsl(160deg 100% 50%);
  stroke: ${DEMO_COLORS_DARK.complementary500};
  stroke-width: 4px;
  stroke-linecap: round;
  stroke-linejoin: round;
`;

const ButtonText = styled.span`
  display: inline-block;
  font-weight: var(--font-weight-medium);
  /* Optical alignment */
  transform: translateY(-1px);
  white-space: nowrap;
`;

export default CheckmarkButton;
